import type { MonthKey } from "./types";

/** 期首月始まりの12ヶ月キー配列 (例: startMonth=4 なら ["04","05",...,"03"]) */
export function getOrderedMonthKeys(startMonth: number): MonthKey[] {
  const keys: MonthKey[] = [];
  for (let i = 0; i < 12; i++) {
    const m = ((startMonth - 1 + i) % 12) + 1;
    keys.push(String(m).padStart(2, "0"));
  }
  return keys;
}

/** 月キー配列に対応する見出しラベル ("4月" / "12月" 等) */
export function getMonthHeaderLabels(startMonth: number): string[] {
  return getOrderedMonthKeys(startMonth).map((k) => `${parseInt(k, 10)}月`);
}

/** "4月" 形式のラベルを "04" に正規化。失敗時 null。 */
export function parseMonthHeader(label: string): MonthKey | null {
  const m = label.trim().match(/^(\d{1,2})月$/);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  if (n < 1 || n > 12) return null;
  return String(n).padStart(2, "0");
}
